// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__2J6fK","showLoader":"Loader_showLoader__QlAML","blockLoader":"Loader_blockLoader__3cPQl","rotate":"Loader_rotate__2usO4"};